import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarIcon,
  PersonIcon,
  AlertIcon,
  CheckCircleIcon,
  ReloadIcon,
} from "../../../images/icons/icons";
import "../../../styles/payrole-system/payrole-processor.css";
import HRDiscrepancyManagement from "../payrole-tabs/HRDiscrepancyManagement";
import ProcessingNotifications from "../payrole-tabs/proceesing-flow/ProcessingNotifications";
import { fetchEmployeePayrollNotificationsData } from "../../../redux/payrole-reducers/payroleSlice";

const ProcessingFlow = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { employeePayrollNotificationsLoading } = useSelector(
    (state) => state.payrole
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isGym = userInfoData?.account_type === "gym";
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const [activeTab, setActiveTab] = useState("employee");
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    accountType: "",
    selectedMonth: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    gym_id: allFilters.selectedGym?.value || "",
    account_type: allFilters.accountType?.value || "",
    month: allFilters.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getNotifications = (filters) => {
    dispatch(
      fetchEmployeePayrollNotificationsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getNotifications(filters);
  }, [filters]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isClusterManager && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      account_type: allFilters.accountType?.value || "",
      month: allFilters.selectedMonth?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.accountType,
    allFilters.selectedMonth,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <div className="pp-payroll-processing-flow">
      {/* <div className="pp-payroll-flow-header">
        <h1 className="pp-payroll-flow-title">Payroll Processing Flow</h1>
        <div className="pp-payroll-badges">
          <span className="pp-payroll-badge pp-payroll-badge-pending">
            △ 2 Pending
          </span>
          <span className="pp-payroll-badge pp-payroll-badge-action">
            ⚠ 2 Action Required
          </span>
        </div>
      </div> */}

      {/* <div className="pp-payroll-system-controls">
        <h2 className="pp-payroll-controls-title">System Controls</h2>
        <div className="pp-payroll-controls-buttons">
          <button className="pp-payroll-btn pp-payroll-btn-primary">
            <CalendarIcon color="#fff" />
            Process Monthly Payroll
          </button>
          <button className="pp-payroll-btn pp-payroll-btn-secondary">
            <CheckCircleIcon />
            Finalize Payrolls (7th)
          </button>
        </div>
      </div> */}

      <div className="pp-payroll-employee-notifications">
        <div className="pp-bulk-header" style={{ padding: "20px 20px 0 20px" }}>
          <div className="pp-employee-payroll-card-header">
            <span>Employee Notifications</span>
            <button
              variant="dark"
              type="button"
              onClick={() => getNotifications(filters)}
            >
              <ReloadIcon />
            </button>
          </div>
        </div>

        <ProcessingNotifications
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />

        {/* <div className="pp-payroll-tabs-nav">
          <button
            className={`pp-payroll-tab-trigger ${
              activeTab === "employee" ? "active" : ""
            }`}
            onClick={() => setActiveTab("employee")}
          >
            <PersonIcon color="#6b7280" />
            Employee View
          </button>
          <button
            className={`pp-payroll-tab-trigger ${
              activeTab === "hr" ? "active" : ""
            }`}
            onClick={() => setActiveTab("hr")}
          >
            <AlertIcon color="#6b7280" />
            HR Dashboard
          </button>
        </div>

        {activeTab === "employee" ? (
          <ProcessingNotifications
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        ) : (
          <HRDiscrepancyManagement userInfoData={userInfoData} />
        )} */}
      </div>
    </div>
  );
};

export default ProcessingFlow;
